/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Directorone2Inputs */

const ja_company_companydetails_directorone2 = /** @type {(inputs: Company_Companydetails_Directorone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バース マルテ - 取締役`)
};

const en_company_companydetails_directorone2 = /** @type {(inputs: Company_Companydetails_Directorone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malte Barth - Director`)
};

/**
* | output |
* | --- |
* | "Malte Barth - Director" |
*
* @param {Company_Companydetails_Directorone2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_directorone2 = /** @type {((inputs?: Company_Companydetails_Directorone2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Directorone2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_directorone2(inputs)
	return en_company_companydetails_directorone2(inputs)
});
export { company_companydetails_directorone2 as "company_companyDetails_directorOne" }